import { Decodable } from "./_decodable";

class AccountTag extends Decodable {
    
    id?: number;
    name?: String;
    hexadecimalColor?: String;
    
}

export { AccountTag };
